import React from 'react';
import { Link } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu';
import map from 'lodash/map';

import { css } from 'glamor';
import typography from '../../utils/typography';

// import logo from '../../assets/logos/lucastswick-logo-black.svg';

import { shadowless, hideOnPrint } from '../../styles';

let styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: typography.rhythm(1),
    height: typography.rhythm(1),
    right: typography.rhythm(1),
    top: typography.rhythm(1),
  },
  bmBurgerBars: {
    background: '#373a47',
  },
  bmCrossButton: {
    height: typography.rhythm(1),
    width: typography.rhythm(1),
  },
  bmCross: {
    background: '#bdc3c7',
  },
  bmMenu: {
    background: '#373a47',
    padding: `${typography.rhythm(0.5)} ${typography.rhythm(0.5)}`,
  },
  bmMorphShape: {
    fill: '#373a47',
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: typography.rhythm(1),
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.2)',
  },
};

class TopNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  componentWillMount() {
    this.props.loadTheme();
    this.props.load();
  }

  componentWillReceiveProps(nextProps) {
    const { colors } = nextProps.theme;
    styles.bmMenu.background = colors[0];
    styles.bmCross.background = colors[1];
    styles.bmItemList.color = nextProps.theme.baseColor;
  }

  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  render() {
    const { theme, work } = this.props;

    const buttonStyle = css({
      color: theme.colors[1],
      '&:hover': {
        color: theme.colors[2],
      },
    });

    return (
      <Menu
        isOpen={this.state.menuOpen}
        onStateChange={state => this.handleStateChange(state)}
        right
        styles={styles}
        pageWrapId={'page-wrap'}
        outerContainerId={'outer-container'}
        {...hideOnPrint}
      >
        {map(work, w => {
          if (w.hidden) return null;
          return (
            <Link
              onClick={() => this.closeMenu()}
              key={w.uid}
              {...shadowless}
              to={w.link}
              {...buttonStyle}
            >
              {w.title}
            </Link>
          );
        })}
        <br />
        <Link
          onClick={() => this.closeMenu()}
          className="menu-item"
          {...shadowless}
          {...buttonStyle}
          to="/"
        >
          Home
        </Link>
        <Link
          onClick={() => this.closeMenu()}
          className="menu-item"
          {...shadowless}
          {...buttonStyle}
          to="/about"
        >
          About
        </Link>
        <Link
          onClick={() => this.closeMenu()}
          className="menu-item"
          {...shadowless}
          {...buttonStyle}
          to="/immersive-scholar-residency-at-NCSU"
        >
          Immersive Scholar
        </Link>
        <Link
          onClick={() => this.closeMenu()}
          className="menu-item"
          {...shadowless}
          {...buttonStyle}
          to="/cv"
        >
          CV
        </Link>
        <Link
          onClick={() => this.closeMenu()}
          className="menu-item"
          {...shadowless}
          {...buttonStyle}
          to="/contact"
        >
          Contact
        </Link>
      </Menu>
    );
  }
}

export default TopNav;



// WEBPACK FOOTER //
// ./src/components/TopNav/TopNav.js